import { useState, useEffect } from 'react';

interface ModernImageOptions {
  webp: string;
  fallback: string;
}

export const useModernImage = ({ webp, fallback }: ModernImageOptions): string => {
  const [imageSrc, setImageSrc] = useState(fallback);

  useEffect(() => {
    // Check if browser supports WebP
    const webpSupported = (() => {
      const canvas = document.createElement('canvas');
      canvas.width = 1;
      canvas.height = 1;
      return canvas.toDataURL('image/webp').indexOf('data:image/webp') === 0;
    })();

    if (webpSupported) {
      setImageSrc(webp);
    }
  }, [webp, fallback]);

  return imageSrc;
};